var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,3h-21C0.7,3,0,2.3,0,1.5S0.7,0,1.5,0h21C23.3,0,24,0.7,24,1.5S23.3,3,22.5,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,11h-21C0.7,11,0,10.3,0,9.5S0.7,8,1.5,8h21C23.3,8,24,8.7,24,9.5S23.3,11,22.5,11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,19h-21C0.7,19,0,18.3,0,17.5S0.7,16,1.5,16h21c0.8,0,1.5,0.7,1.5,1.5S23.3,19,22.5,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon_hamburger.2322cf9ef3594c7a30dfe2b212b42877.svg";
export { ForwardRef as ReactComponent };